// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_G-R","type":"styles_type__1xnmn","choices":"styles_choices__3wKUP"};